<header class="navbar navbar-fixed-top bg-system">
    <ul class="nav navbar-nav navbar-left">
        <li class="hidden-xs">
            <a class="navbar-fullscreen toggle-active" href="/" ng-click="mainPage()">
                <img src="img/logo-blue.svg" alt="Hodxpress.com">
            </a>
        </li>
    </ul>

    <ul class="nav navbar-nav navbar-right" style="width: 100%;">
        <div class="btn-group pull-right">
            <a href="#" 
                class="hod-button blue ml10" 
                ng-click="newData()">
                New Driver
            </a>
        </div>
    </ul>
</header>

<header class="navbar navbar-fixed-top subnavbar bg-system" ng-if="isActive(['calisan-yonetimi','calisan-yonetimi?type=truck','yeni-calisan'])">
        
    <ul class="nav navbar-nav navbar-left">
        <input type="text" 
            class="btn btn-operation ml10 text-input" 
            ng-model="data.term" 
            placeholder="By Name">
    </ul>
</header>

<header class="navbar navbar-fixed-top subnavbar bg-system" ng-if="isActive(['calisan-yonetimi?type=office','yeni-calisan'])">
    
    <ul class="nav navbar-nav navbar-left">
        <input type="text" 
            class="btn btn-operation ml10 text-input w300" 
            ng-model="data.term" 
            placeholder="Çalışan Ara">

        <a href="#" 
            class="btn btn-danger btn-rounded btn-sm ml10" 
            ng-click="delete('set')" 
            ng-disabled="deleted.length == 0" 
            ng-if="deleted.length > 0">
            <i class="fa fa-trash"></i> Delete
        </a>
    </ul>

    <ul class="nav navbar-nav navbar-right">

        <!-- <li class="hidden-xs">
            <a href="/yeni-calisan?type=office" class="btn btn-warning btn-rounded">
                Yeni Ofis Çalışanı Ekle 
            </a>
        </li> -->

    </ul>

</header>

<header class="navbar navbar-fixed-top subnavbar bg-system" ng-if="isActive(['ekip-yonetimi','yeni-ekip'])">
        
    <ul class="nav navbar-nav navbar-left">
        <input type="text" 
            class="btn btn-operation ml10 text-input w300" 
            ng-model="data.term" 
            placeholder="Ekip Ara">

        <a href="#" 
            class="btn btn-danger btn-rounded btn-sm ml10" 
            ng-click="delete('set')" 
            ng-disabled="deleted.length == 0" 
            ng-if="deleted.length > 0">
            <i class="fa fa-trash"></i> Delete
        </a>
    </ul>

    <ul class="nav navbar-nav navbar-right">
    
        <!-- <li class="hidden-xs">
            <a href="/yeni-ekip" class="btn btn-warning btn-rounded">
                Yeni Ekip Ekle 
            </a>
        </li> -->

    </ul>
    
</header>
